/* eslint-disable no-undef, no-unused-vars */
import {
  CamFileInfo,
  MailJob,
  MailJobFile,
} from "../stores/AppStore/ApplicationStore";
import { ConfigApi } from "./base/ConfigApi";
import SpaToolsApiClient from "./base/SpaToolsApiClient";

export type ReviewFile = {
  fileName: string;
  fileGuid: string;
  isUpload: boolean;
  pages: number;
};

export type RecipientInfo = {
  rc_FirstName: string;
  rc_CustomFirstName: string;
  rc_LastName: string;
  rc_CustomLastName: string;
  contactType?: string;
  rc_SendMail: boolean | string;
  rc_BuilderAccount: boolean;
  rc_CustomAddress: string;
  rc_Address: string;
  rc_CustomAddress2: string;
  rc_CustomCity: string;
  rc_CustomState: string;
  rc_Address2: string;
  rc_City: string;
  rc_State: string;
  rc_CustomZipcode: string;
  rc_Zipcode: string;
  residentContactKey: number;
  residentKey: number;
  communityDeveloperLinkKey: number;
  unitType: number;
  streetName: string;
};

export type PropertyJobDetail = {
  communityKey: string;
  propertyName: string;
  files: MailJobFile[];
  numberOfRecipients: number;
  numberOfRecipientsEmailed: number;
  numberOfRecipientsPrinted: number;
  numberOfDocumentsPrinted: number;
  numberOfDocumentsPagesPrinted: number;
  numberOfDocumentsEmailed: number;
  numberOfDocumentsPagesEmailed: number;
  numberOfDocumentsPages: number;
  numberOfDocuments: number;
  recipientsCount: number;
};

export default class Api_v2 extends SpaToolsApiClient {
  constructor(configApi: ConfigApi) {
    super({ ...configApi, domain: configApi.domain + "v2/" });
  }

  public async UploadAndReviewFilesInfo(
    formData: FormData
  ): Promise<ReviewFile[]> {
    return await this.post("/XMLAndPDF/ReviewFilesInfo", formData)
      .then((res) => res.data)
      .catch(() => []);
  }

  public async GetRecipientInfo(
    fileInfo: CamFileInfo,
    comTypeId: number
  ): Promise<RecipientInfo> {
    return await this.post("/Recipients/GetRecipientInfo", {
      fileInfo: fileInfo,
      comTypeId: comTypeId,
    })
      .then((res) => res.data)
      .catch(() => undefined);
  }

  public async GetExelFile(mailJob: MailJob): Promise<any> {
    return await this.postBlob("/MailJob/GetExelFile", mailJob)
      .then((res) => res.data)
      .catch(() => undefined);
  }

  public async GetJobDescription(
    mailJob: MailJob
  ): Promise<PropertyJobDetail[]> {
    return await this.post("/MailJob/GetJobDescription", mailJob)
      .then((res) => res.data)
      .catch(() => undefined);
  }

  public async Create(mailJob: MailJob): Promise<number> {
    return await this.post("/MailJob/Create", mailJob)
      .then((res) => res.data)
      .catch(() => undefined);
  }

  public async Cancel(mailJob: MailJob): Promise<number> {
    return await this.post("/MailJob/Canceled", mailJob)
      .then((res) => res.data)
      .catch(() => undefined);
  }

  public async Approve(
    employeeKey: string,
    mailJobId: number
  ): Promise<boolean> {
    return await this.post("/MailJob/Approve", {
      jobID: mailJobId,
      appruveEmployKey: employeeKey,
    })
      .then((res) => res.data.success)
      .catch(() => false);
  }

  public async Reject(
    employeeKey: string,
    mailJobId: number,
    reason: string
  ): Promise<any> {
    return await this.post("/MailJob/Reject", {
      jobID: mailJobId,
      rejectEmployKey: employeeKey,
      rejectReason: reason,
    })
      .then((res) => res.data.success)
      .catch(() => false);
  }
}
